import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Row,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
  InputNumber,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import styles from "../../../../assets/styles/styles";
import { labelConfig, staticConfig } from "../../systemAdmin.config";

const BranchTransactionForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    configureTransactionTableSource,
    setConfigureTransactionTableSource,
    transactionCount,
    setTransactionCount,
    currencyData,
    codeValueData,
  } = props;

  const { Title } = Typography;

  // DECLARED VARIABLES FOR FORM
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTransactionLimitDelete = (key) => {
    console.log(key);

    let action = "Delete  ";
    // let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "please confirm action",
      "",
      "Yes",
      "No",

      function () {
        const newData = configureTransactionTableSource.filter(
          (item) => item.id !== key.id
        );
        setConfigureTransactionTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Currency",
      dataIndex: "currencyCode",
    },
    // {
    //   title: "Transaction Type",
    //   dataIndex: "transactionType",
    // },
    {
      title: "Transaction Type",
      dataIndex: "transactionTypeValue",
    },
    {
      title: "Transaction Type Limit",
      dataIndex: "transactionTypeLimit",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureTransactionTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleTransactionLimitDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Branch Transaction Information
        </Title>
      </Divider>
      <BranchTransactionLimitModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        setConfigureTransactionTableSource={setConfigureTransactionTableSource}
        configureTransactionTableSource={configureTransactionTableSource}
        transactionCount={transactionCount}
        setTransactionCount={setTransactionCount}
        currencyData={currencyData}
        codeValueData={codeValueData}
      />

      {configureTransactionTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {configureTransactionTableSource.length > 1
                ? "Added Branch Transactions"
                : "Added Branch Transaction"}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={configureTransactionTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </Form>
  );
};
export default BranchTransactionForm;

const BranchTransactionLimitModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigureTransactionTableSource,
    configureTransactionTableSource,
    isModalOpen,
    setIsModalOpen,
    transactionCount,
    setTransactionCount,
    currencyData,
    codeValueData,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleBranchTransactionSave = (formValues) => {
    // console.log(formValues);

    const newTransactionLimit = {
      key: transactionCount,
      id: transactionCount,
      transactionType: formValues.transactionType,
      transactionTypeValue: formValues.transactionType
        ? codeValueData.find(
            (item) => item.value === formValues.transactionType
          ).label
        : "-",
      currencyCode: formValues.currencyCode,
      transactionTypeLimit: formValues.transactionTypeLimit.toLocaleString(),
    };
    setTransactionCount(transactionCount + 1);

    let duplicateFound = configureTransactionTableSource.some(
      (item) =>
        item.currencyCode === newTransactionLimit.currencyCode &&
        item.transactionTypeValue === newTransactionLimit.transactionTypeValue
    );

    if (duplicateFound) {
      BOM.AlertMsg(
        cnt.WARNING,
        "Duplicate transaction type and currency combination not allowed!"
      );
      return;
    }
    setConfigureTransactionTableSource([
      ...configureTransactionTableSource,
      newTransactionLimit,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Transaction Limit Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleBranchTransactionSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"currencyCode"}
                label={labelConfig.currency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select"
                  )}
                  options={currencyData}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionType"
                label={labelConfig.transcationType}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transcationType),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transcationType,
                    "select"
                  )}
                  options={codeValueData}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionTypeLimit"
                label={labelConfig.limit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.limit),
                  },
                ]}
              >
                <InputNumber
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/,/g, "")}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.limit)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
